
import React from 'react';

const ArrowIcon = (props) => {
    const orientations = {
        top: 90,
        bottom: 90,
        left: 180,
        right: 0
    }
    let styles = {
        fill: props.fill ? props.fill : "currentColor",
        transform: props.orientation ? `rotate(${orientations[props.orientation]}deg)` : `rotate(0deg)`
    }
    return (
        <svg className="arrow-icon" style={styles} width="24" height="24" viewBox="0 0 24 24">
            <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
        </svg>
    );
};

export default ArrowIcon;